import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';
import { getSectionNavColor } from 'styles/helpers/getThemeStyles';

export const ErrorMessageTypography = styled(Typography)(({ theme }) => ({
  color: getSectionNavColor(theme),
  lineHeight: 1.5,
  fontSize: '12px'
}));

export default ErrorMessageTypography;
